/*jshint esversion: 6 */

import $ from "jquery";

function navigationToggle() {
  let $body = $("body");
  let $mobileToggle = $(".page-header__nav-toggle");
  let mobileToggleOpenClass = "page-header__nav-toggle--open";
  let bodyOpenClass = "navigation-open";
  let $targetElement = $(".page-header__mobile");

  $(".page-overlay-navigation__main-navigation a").on("click", () => {
    $body.removeClass(bodyOpenClass);
    $mobileToggle
      .removeClass(mobileToggleOpenClass)
      .attr("aria-expanded", false);
  });

  $mobileToggle.on("click", () => {
    if ($mobileToggle.hasClass(mobileToggleOpenClass)) {
      $body.removeClass(bodyOpenClass);
      $mobileToggle
        .removeClass(mobileToggleOpenClass)
        .attr("aria-expanded", false);
      $targetElement.attr('aria-hidden', true);
    } else {
      $mobileToggle.addClass(mobileToggleOpenClass).attr("aria-expanded", true);
      $targetElement.attr('aria-hidden', false);
      $body.addClass(bodyOpenClass);

      setTimeout(() => {
        $targetElement.find('a:first').focus();
      }, 100);

      // Close the navigation when the escape key is pressed
      $(document).on("keydown", function (event) {
        if (event.key === "Escape" || event.keyCode === 27) {
          $body.removeClass(bodyOpenClass);
          $mobileToggle
            .removeClass(mobileToggleOpenClass)
            .attr("aria-expanded", false)
            .focus();
          $targetElement.attr('aria-hidden', true);
        }
      });
    }
  });
}

export default navigationToggle;
